// extracted by mini-css-extract-plugin
module.exports = {"navbar-wrapper":"Navbar_navbar-wrapper__2_D-A","logo":"Navbar_logo__1nFMD","username":"Navbar_username__1frxz"};